<div class="loader loader--ajax" loader *ngIf="isLoading">
  <!-- prettier-ignore -->
  <div class="preloader-circle"><div></div><div></div><div></div><div></div></div>
</div>
